/** Error cuando un pull manual forzado no obtuvo datos remotos. */
export class SyncPullFailedError extends Error {
  readonly domain: 'catalog' | 'fiado';

  constructor(domain: 'catalog' | 'fiado', message: string) {
    super(message);
    this.name = 'SyncPullFailedError';
    this.domain = domain;
  }
}

export function formatForceFullSyncFailure(parts: string[]): string {
  if (parts.length === 0) return 'No se pudo completar la sincronización.';
  return `No se pudo completar: ${parts.join(', ')}.`;
}
